import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import Tabs from '../../../../components/tabs';
import TimesheetsList from './../../lists/timesheets';
import { getClientWorkers } from '../../../../reducers/clients';
import { getAdminDetails } from '../../../../reducers/users';
import { RoleDefinitions } from '../../../../utilities/roles';

class ClientTime extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { role, profile, details, getClientWorkers, getAdminDetails } = this.props;
        const hmFilter = worker => (role.role === RoleDefinitions.ClientHiringManager.type ? worker.hm_id === profile.id : true);
        getClientWorkers(role.id, hmFilter);
        getAdminDetails(details.admin_id);
    }

    render() {
        const { workers, admin, history } = this.props;
        const defaultTab = (history.location.state || { defaultTab: 0 }).defaultTab;

        if (!workers || !admin) return null;

        let tabs = [
            {
                title: <FormattedMessage {...messages.toApprove} />,
                content: <TimesheetsList key={0} workers={workers} filter={['submitted', 'notapproved']} />
            },
            { title: <FormattedMessage {...messages.approved} />, content: <TimesheetsList key={1} workers={workers} filter={['approved', 'autoapproved']} /> },
            { title: <FormattedMessage {...messages.pending} />, content: <TimesheetsList key={2} workers={workers} filter={'pending'} />, style: 'light' }
        ];

        return (
            <React.Fragment>
                <Tabs items={tabs} defaultTab={defaultTab} pageWide title={<FormattedMessage {...messages.timesheets} />} isPageTitle={true} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        profile: state.identity.profile,
        admin: state.users.adminDetails,
        details: state.identity.details,
        workers: state.clients.workers
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientWorkers,
            getAdminDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientTime);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/tenants/client/index.jsx